import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("token");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me check while returning from OAuth callback
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    sessionStorage.removeItem("open_tabs");
    sessionStorage.removeItem("awb_reminder_shown");
    sessionStorage.removeItem("split_pane");
    setUser(data.user);
    return data.user;
  };

  const setSession = (token, u) => {
    localStorage.setItem("token", token);
    sessionStorage.removeItem("open_tabs");
    sessionStorage.removeItem("awb_reminder_shown");
    sessionStorage.removeItem("split_pane");
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("open_tabs");
    sessionStorage.removeItem("awb_reminder_shown");
    sessionStorage.removeItem("split_pane");
    setUser(null);
  };

  const isTeam = user && (user.role === "team" || user.role === "admin");
  const isDispatch = user && user.role === "dispatch";

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setSession, refresh: checkAuth, isTeam, isDispatch }}>
      {children}
    </AuthContext.Provider>
  );
}
